import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { Box } from '@mui/material';

interface Props {
  data: { status: string; count: number }[];
}

const ApplicantsCompositionChart: React.FC<Props> = ({ data }) => {
  const chartData = data.map((item, index) => ({
    id: index,
    value: item.count,
    label: item.status,
  }));

  return (
    <Box height={280} width="100%" display="flex" justifyContent="center">
      <PieChart
        series={[
          {
            data: chartData,
            innerRadius: 30,
            paddingAngle: 5,
            cornerRadius: 5,
            highlightScope: { faded: 'global', highlighted: 'item' },
            faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
          },
        ]}
        width={350}
        height={250}
        slotProps={{
          legend: {
            direction: "row",
            position: {
              vertical: 'bottom',
              horizontal: 'middle'
            }
          }
        }}
      />
    </Box>
  );
};

export default ApplicantsCompositionChart;
